import Vue from 'vue'
import '@mdi/font/css/materialdesignicons.css'
import '@fontsource/noto-sans-sc/400.css'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from '@/router';

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
